import { render } from "./Stepper.vue?vue&type=template&id=391f31f4"
import script from "./Stepper.vue?vue&type=script&lang=ts"
export * from "./Stepper.vue?vue&type=script&lang=ts"
script.render = render

export default script